import { render, staticRenderFns } from "./RiskForecastFlowShowBlock.vue?vue&type=template&id=54325e03&scoped=true"
import script from "./RiskForecastFlowShowBlock.vue?vue&type=script&lang=js"
export * from "./RiskForecastFlowShowBlock.vue?vue&type=script&lang=js"
import style0 from "./RiskForecastFlowShowBlock.vue?vue&type=style&index=0&id=54325e03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54325e03",
  null
  
)

export default component.exports